import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary text-white border-t border-primary-light pt-16 pb-8" data-id="element-129">
      <div className="container mx-auto px-6 md:px-12" data-id="element-130">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-131">
          {/* Brand */}
          <div className="col-span-1 lg:col-span-1" data-id="element-132">
            <a href="#home" className="text-3xl font-serif font-bold tracking-wider flex items-center gap-2 mb-6" data-id="element-133">
              WC Home Remodeling
            </a>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-134">
              Over 20 years transforming homes with quality, transparency, and
              attention to detail. Your vision, our expertise.
            </p>
            <div className="flex gap-4" data-id="element-135">
              <a href="#" className="w-10 h-10 rounded-sm bg-primary-light flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-136">
                <Facebook size={20} data-id="element-137" />
              </a>
              <a href="#" className="w-10 h-10 rounded-sm bg-primary-light flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-138">
                <Instagram size={20} data-id="element-139" />
              </a>
              <a href="#" className="w-10 h-10 rounded-sm bg-primary-light flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-140"></a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-141">
            <h4 className="text-lg font-serif font-bold mb-6 border-b border-primary-light pb-2 inline-block" data-id="element-142">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-143">
              <li data-id="element-144">
                <a href="#home" className="text-gray-400 hover:text-accent transition-colors" data-id="element-145">
                  Home
                </a>
              </li>
              <li data-id="element-146">
                <a href="#about" className="text-gray-400 hover:text-accent transition-colors" data-id="element-147">
                  About Us
                </a>
              </li>
              <li data-id="element-148">
                <a href="#services" className="text-gray-400 hover:text-accent transition-colors" data-id="element-149">
                  Services
                </a>
              </li>
              <li data-id="element-150">
                <a href="#projects" className="text-gray-400 hover:text-accent transition-colors" data-id="element-151">
                  Projects
                </a>
              </li>
              <li data-id="element-152">
                <a href="#testimonials" className="text-gray-400 hover:text-accent transition-colors" data-id="element-153">
                  Testimonials
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-154">
            <h4 className="text-lg font-serif font-bold mb-6 border-b border-primary-light pb-2 inline-block" data-id="element-155">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-156">
              <li className="text-gray-400" data-id="element-157">Kitchen Remodeling</li>
              <li className="text-gray-400" data-id="element-158">Bathroom Remodeling</li>
              <li className="text-gray-400" data-id="element-159">Home Additions</li>
              <li className="text-gray-400" data-id="element-160">Permit Management</li>
              <li className="text-gray-400" data-id="element-161">Full Remodeling</li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-162">
            <h4 className="text-lg font-serif font-bold mb-6 border-b border-primary-light pb-2 inline-block" data-id="element-163">
              Newsletter
            </h4>
            <p className="text-gray-400 mb-4" data-id="element-164">
              Subscribe to receive remodeling tips and exclusive offers.
            </p>
            <form className="flex flex-col gap-3" onSubmit={e => e.preventDefault()} data-id="element-165">
              <input type="email" placeholder="Your email address" className="px-4 py-3 bg-primary-light border border-gray-700 rounded-sm focus:outline-none focus:border-accent text-white" data-id="element-166" />
              <button className="bg-accent hover:bg-accent-hover text-white font-medium py-3 rounded-sm transition-colors" data-id="element-167">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-primary-light pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-168">
          <p className="text-gray-500 text-sm" data-id="element-169">
            &copy; {new Date().getFullYear()} RenovaPro. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-170">
            <a href="#" className="hover:text-accent transition-colors" data-id="element-171">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-accent transition-colors" data-id="element-172">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}